import React from 'react';
import { OFFER_ANCHOR } from '../data/fono';
const blocks = [{
  heading: '😩 STOP CREATING SESSION MATERIALS FROM SCRATCH',
  body: 'Your time should go into your professional work — not rebuilding cards, worksheets, games and visual resources every week. FONO KIDS PRO™ brings the materials together for you. Visual cards. Printable games. Picture scenes. Sorting activities. Sound activities. Language resources. Auditory activities. Sequencing and storytelling materials. Everything organized so you can find a relevant resource, prepare it and adapt it according to your professional goals.',
  kicker: 'Less material creation. More ready-to-use resources.'
}, {
  heading: '⏱️ LESS PREP. MORE READY-TO-USE MATERIAL.',
  body: 'Need a Speech & Articulation activity? It’s there. Need a visual scene for Oral Language? It’s there. Need Vocabulary & Categories cards? They’re there. Need a Phonological Awareness activity? Auditory Attention & Memory? Sequencing & Narrative?',
  kicker: 'Open the system. Choose the area. Find the activity. Prepare it.'
}];
export function ProblemSection() {
  return <section className="border-y-4 border-mint bg-white px-3 py-5 sm:py-7" data-id="element-137" data-mp="ocpz8t045jy4">
      <div className="mx-auto max-w-3xl" data-id="element-138" data-mp="scqqje8b9pml">
        <h2 className="text-center text-xl leading-tight text-teal sm:text-3xl" data-id="element-139" data-mp="sbp3schxnep1">
          What if your session materials were already ready?
        </h2>
        <p className="mt-2 text-center text-[13px] font-medium leading-snug text-charcoal/80 sm:text-base" data-id="element-140" data-mp="122jp9encua9f">
          You already have the professional knowledge. The problem is constantly needing the
          right material to put that knowledge into practice. What can you use for today’s
          speech target? Where are those vocabulary cards you needed? What visual activity
          could support oral language? What can you use for phonological awareness? What
          about auditory attention or sequencing? Instead of starting from a blank page,{' '}
          <strong className="font-extrabold text-teal" data-id="element-141" data-mp="p08xdgznoq9s">FONO KIDS PRO™</strong> gives you an
          organized library of visual, ready-to-use activities across 6 essential areas of
          pediatric speech-language practice.
        </p>
        <p className="mt-1.5 text-center text-sm font-extrabold uppercase tracking-wide text-coral" data-id="element-142" data-mp="y2085091znai">
          Choose it. Print it. Use it.
        </p>

        <div className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-143" data-mp="17z4up16t9kru">
          {blocks.map(block => <a key={block.heading} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border-l-4 border-turq bg-mint/60 p-3.5 transition-colors duration-150 hover:bg-mint" data-id="element-144" data-mp="1301o3cb6n6hr">
              <h3 className="text-base leading-tight text-teal" data-id="element-145" data-mp="1cpl84lamt6e7">{block.heading}</h3>
              <p className="mt-1.5 text-[13px] font-medium leading-snug text-charcoal/80" data-id="element-146" data-mp="1qp30tbr1t3su">
                {block.body}
              </p>
              <p className="mt-auto pt-2 text-[13px] font-extrabold text-coral" data-id="element-147" data-mp="1ls48myqy36xa">
                {block.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}